export default class LocationConfigClient {
    constructor(commonHttpFactory, httpCacheFactory, router, language) {
        this.httpCache = httpCacheFactory.createHttpCache('location_config');
        this.commonHttp = commonHttpFactory.createCommonHttp(
            {
                error_context: 'location_config',
                success_context: 'location_config'
            },
            this.httpCache
        );
        this.router = router;
        this.language = language;
    }

    getConfig() {
        return this.commonHttp
            .get(
                this.router.generate('paysera_map.get_location_config', {
                    '_locale': this.language.getCurrentLanguage()
                })
            )
        ;
    }
}

LocationConfigClient.$inject = ['commonHttpFactory', 'httpCacheFactory', 'router', 'language'];
